// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + chunkId + "." + {"15":"b561c61fdd63d6de52e2","910":"0e58f017bd318fa33882","971":"b630f24b6eda8a3454d9"}[chunkId] + ".js";
};